module.exports = __webpack_public_path__ + "d.no1.3e3e7794.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/d.no1.jpg
// module id = PcUw
// module chunks = 0